// import '../../App.css'

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { color } from 'chart.js/helpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const JobsTrendChart = ({ data }) => {
  const months = data.map(item => item.month.substring(0, 3));

  const PostedColor = getComputedStyle(document.documentElement).getPropertyValue('--cd1').trim();
  const ProgressingColor = getComputedStyle(document.documentElement).getPropertyValue('--cd3').trim();
  const CompletedColor = getComputedStyle(document.documentElement).getPropertyValue('--cd2').trim();
  const CancelledColor = getComputedStyle(document.documentElement).getPropertyValue('--cd4').trim();
  const PendingColor = getComputedStyle(document.documentElement).getPropertyValue('--cd10').trim();
  const ToolTipBG = getComputedStyle(document.documentElement).getPropertyValue('--tooltip-bg').trim();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: 'easeOutQuart'
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      datalabels: { display: false },
      title: {
        display: false,
        text: 'Job Trend',
        color: 'rgb(21, 75, 4)'
      },
      legend: {
        position: 'top',
        align: 'start',
        display: false,
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 10,
          },
          usePointStyle: false,
          generateLabels: (chart) => {
            return chart.data.datasets.map((dataset, i) => ({
              text: dataset.label,
              fillStyle: dataset.borderColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 2,
              pointStyle: 'circle',
              hidden: false,

              datasetIndex: i
            }));
          }
        },
        // Disable click events
        onClick: null,
        onHover: null,
        onLeave: null
      },
      tooltip: {
        backgroundColor: ToolTipBG,
        padding: 12,
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y} jobs`
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    },
    elements: {
      point: {
        radius: 4,
        hoverRadius: 7,
        hitRadius: 10
      },
      line: {
        tension: 0.4 // Smooth curve
      }
    }
  };


  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'Posted',
        data: data.map(item => item.total_jobs_posted),
        borderColor: PostedColor,
        borderColor: PostedColor,
        borderWidth: 1,
        pointBackgroundColor: PostedColor,
        pointBorderWidth: 1,
        pointHoverBackgroundColor: PostedColor,
        fill: false // No fill
      },
      {
        label: 'Pending',
        data: data.map(item => item.jobs_pending),
        borderColor: PendingColor,
        borderColor: PendingColor,
        borderWidth: 1,
        pointBackgroundColor: PendingColor,
        pointBorderWidth: 1,
        pointHoverBackgroundColor: PendingColor,
        fill: false // No fill
      },
      {
        label: 'Progressing',
        data: data.map(item => item.jobs_in_progress),
        borderColor: ProgressingColor,
        borderWidth: 1,
        pointBackgroundColor: ProgressingColor,
        pointBackgroundColor: ProgressingColor,
        pointBorderWidth: 1,
        pointHoverBackgroundColor: ProgressingColor,
        pointHoverBackgroundColor: ProgressingColor,
        fill: false // No fill
      },
      {
        label: 'Completed',
        data: data.map(item => item.jobs_completed),
        borderColor: CompletedColor,
        borderColor: CompletedColor,
        borderWidth: 1,
        pointBackgroundColor: CompletedColor,
        pointBackgroundColor: CompletedColor,
        pointBorderWidth: 1,
        pointHoverBackgroundColor: CompletedColor,
        pointHoverBackgroundColor: CompletedColor,
        fill: false // No fill
      },
      {
        label: 'Canceled',
        data: data.map(item => item.jobs_canceled),
        borderColor: CancelledColor,
        borderColor: CancelledColor,
        borderWidth: 1,
        pointBackgroundColor: CancelledColor,
        pointBackgroundColor: CancelledColor,
        pointBorderWidth: 1,
        pointHoverBackgroundColor: CancelledColor,
        pointHoverBackgroundColor: CancelledColor,
        fill: false // No fill
      }
    ]
  };

  return (
    <div className="chart-container">
      <Line data={chartData} options={options} />
    </div>
  );
};
